import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { theme } from "../../Methods/theme";
import { Wrapper, TitleContainer, DescriptionContainer, Description } from "./styles";
import Row from "../../Shared/Kit/Row";
import Col from "../../Shared/Kit/Col";
import PlusIcon from "../../Assets/Icons/PlusIcon";
import MinusIcon from "../../Assets/Icons/MinusIcon";
import ArrowLeftIcon from "../../Assets/Icons/ArrowLeftIcon";

const Section = (props) => {
  const {
    name,
    item,
    maxHeight,
    direction = "rtl",
    // color = "gray",
  } = props;

  const {
    id,
    title = title || "اطلاعیه",
    // icon = icon || null,
    description = description || "",
    // component = component || null,
    entryDate = entryDate || "",
    url = url || "#",
    expanded = expanded || false,
  } = item;

  // const Icon = icon || null
  const Icon = ArrowLeftIcon;

  const _id = `accordion-${name}-${item.id}`;

  const [expand, setExpand] = useState(false);

  useEffect(() => {
    if (expanded)
      toggle();
  }, [])
  const toggle = () => {
    let descriptionElement = document.getElementById(_id);
    if (descriptionElement && descriptionElement.style) {
      if (!expand) {
        descriptionElement.style.maxHeight = maxHeight || "2500px";
      } else {
        descriptionElement.style.maxHeight = "0";
      }
    }
    setExpand(!expand);
  };

  return (
    <>
      <Wrapper
        className="accordion-wrapper"
      >
        <TitleContainer
          onClick={toggle}
          expand={expand}
          hasIcon={Icon ? true : false}
          direction={direction}
        >
          <Row className="title-and-icon">
            {Icon &&
              <Col className="icon">
                <Icon />
              </Col>
            }
            <Row className="title">
              {title}
            </Row>
            <Row className="entrydate">
              {entryDate}
            </Row>
          </Row>
          {/* <Col className="arrow-icon">
            {expand ?
              <MinusIcon />
              : <PlusIcon />
            }
          </Col> */}
        </TitleContainer>
        <DescriptionContainer
          id={_id}
          className={`hide-scroll-bar`}
          expand={expand}
          // hasComponent={component ? true : false}
          hasComponent={false}
        >
          <Row>
            {item &&
              <Description color={theme.primary}>
                {item.description}
                <br />
              </Description>
            }
          </Row>
          <Row>
            <Link className="link" to={url} target="blank" >ادامه مطلب</Link>
          </Row>
        </DescriptionContainer>
      </Wrapper>
    </>
  );
};

export default Section;